import Breadcrumb, { BreadcrumbProps } from "antd/es/breadcrumb";
import { Link, useLocation, useParams } from "react-router-dom";
import { BLOG_POSTS } from "../pages/blog/blogPosts";

export function AppBreadcrumb() {
    const location = useLocation();
    const { slug } = useParams();

    const pathSnippets = location.pathname.split("/").filter(Boolean);

    const items: BreadcrumbProps["items"] = [
        {
            title: <Link to="/">Avaleht</Link>,
        },
    ];

    pathSnippets.forEach((segment, index) => {
        const url = `/${pathSnippets.slice(0, index + 1).join("/")}`;
        if (segment === slug) {
            const post = BLOG_POSTS.find((p) => p.slug === slug);

            items.push({
                title: post?.title ?? segment,
            });
            return;
        }
        const nameMap: Record<string, string> = {
            blog: "Blogi",
            about: "Meist",
            contact: "Kontakt",
        };
        items.push({
            title: nameMap[segment] ? <Link to={url}>{nameMap[segment]}</Link> : segment,
        });
    });

    return <Breadcrumb items={items} />;
}
